import React, { useState, useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  useTheme,
  Paper,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Switch,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import Header from "../Dashboard/Header";
import { tokens } from "../../theme";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function DashboardSettings() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const navigate = useNavigate();

  // State for dialog
  const [openDialog, setOpenDialog] = useState(false);

  // User data state
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [Reportname, setReportName] = useState({
    Reportname: "",
    TabName: "",
  });

  // Fetch users from API
  const fetchUsers = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/userAPI/list",
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const userList = Object.values(response.data.users);
      // console.log(userList);

      const transformedUsers =
        Array.isArray(userList) &&
        userList.map((user) => ({
          id: user.user_Id,
          name: user.user_Name,
          email: user.user_Email,
          role: user.user_Role,
          enabled: true, // default enabled value
          user_Id: user.user_Id,
          user_Email: user.user_Email,
          user_Role: user.user_Role,
          user_Name: user.user_Name,
        }));

      // console.log(transformedUsers);

      setUsers(transformedUsers);
    } catch (error) {
      console.error("Error fetching users from API:", error);
    }
  };

  // Fetch users, dashboard configs, and toggle configurations on component mount
  useEffect(() => {
    fetchUsers();
  }, []);

  // Handle configure button click
  const handleConfigureClick = async (RprtName, TabName) => {
    setReportName({
      Reportname: RprtName,
      TabName: TabName,
    });
    setOpenDialog(true);

    const DataBody = {
      cmpid,
      dashboardname: RprtName,
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/reports/adminconfig/list",
        DataBody,
        { headers: { Authorization: token } }
      );
      const ListData = Object.values(response.data);
      // console.log(ListData)
      const enabledUserIds = new Set(ListData.map((item) => item.user_id));

      const transformedUsers = users.map((user) => {
        const isEnabled = enabledUserIds.has(user.user_Id); // true if user_id exists in ListData
        return {
          id: user.user_Id,
          name: user.user_Name,
          email: user.user_Email,
          role: user.user_Role,
          enabled: isEnabled,
          user_Id: user.user_Id,
          user_Email: user.user_Email,
          user_Role: user.user_Role,
          user_Name: user.user_Name,
        };
      });

      // console.log("naresh sir log",transformedUsers)

      setUsers(transformedUsers);
    } catch (error) {
      console.error("Error saving configuration:", error);
    }
  };

  //   create user wise config ====================

  const handleSaveConfiguration = async () => {
    // console.log("user data", users);

    const SaveConfigBodyList = users.map((user) => ({
      cmpid: cmpid,
      id: user.id,
      dashboardname: Reportname.Reportname,
      isenable: user.enabled === true ? 1 : 0,
      category: Reportname.TabName,
    }));

    // console.log("body", SaveConfigBodyList);

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/reports/config/create",
        SaveConfigBodyList,
        { headers: { Authorization: token } }
      );

      Swal.fire({
        title: "Success!",
        text: ` configuration Saved successfully`,
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: 300,
        padding: "1em",
        customClass: { popup: "small-alert" },
      });
    } catch (error) {
      console.error("Error fetching company list:", error);
    }

    setOpenDialog(false);
  };

  // Handle dialog close
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  // Handle user toggle switch
  const handleUserToggle = (userId) => {
    const updatedUsers = users.map((user) =>
      user.id === userId ? { ...user, enabled: !user.enabled } : user
    );

    setUsers(updatedUsers);
  };

  return (
    <Box mt={9} mr={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Dashboard Settings"
          subtitle="Configure your dashboard widgets and preferences"
        />

        <Button
          variant="contained"
          size="small"
          sx={{
            height: "35px",
            minHeight: "35px",
            backgroundColor: colors.blueAccent[700],
            color: colors.primary[150],
            "&:hover": {
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
          }}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      <Box mt="20px">
        {/* Module Dashboard Accordion */}
        <Accordion
          sx={{
            backgroundColor: colors.primary[400],
            marginBottom: "8px",
            "&:before": { display: "none" },
            "& .MuiAccordionSummary-root": {
              minHeight: "40px !important",
              padding: "0 16px",
            },
            "& .MuiAccordionSummary-content": {
              margin: "8px 0 !important",
            },
            "& .MuiAccordionDetails-root": {
              padding: "8px 16px 16px",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
          >
            <Typography variant="h5" sx={{ fontSize: "16px !important" }}>
              Shraddha Modules Dashboard
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={1}>
              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Approval Module
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Track and manage approval workflows and pending requests
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "approvalModule",
                          "Module Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Payable Ageing Analysis
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Analyze accounts payable by aging categories
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "payableAgeingAnalysis",
                          "Module Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Payment Efficiency Ratio
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Measure payment processing efficiency
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "paymentEfficiencyRatio",
                          "Module Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Sales Dashboard Accordion */}
        <Accordion
          sx={{
            backgroundColor: colors.primary[400],
            marginBottom: "8px",
            "&:before": { display: "none" },
            "& .MuiAccordionSummary-root": {
              minHeight: "40px !important",
              padding: "0 16px",
            },
            "& .MuiAccordionSummary-content": {
              margin: "8px 0 !important",
            },
            "& .MuiAccordionDetails-root": {
              padding: "8px 16px 16px",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
          >
            <Typography variant="h5" sx={{ fontSize: "16px !important" }}>
              Sales Dashboard
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={1}>
              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Average Order Value
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Track average revenue per order and identify trends
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "averageOrderValue",
                          "Sales Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Indian States Sales Distribution
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      View sales performance across different Indian states
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "indianStatesSalesDistribution",
                          "Sales Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      New vs Repeat Customers
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Compare acquisition vs retention metrics
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "newVsRepeatCustomers",
                          "Sales Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Top 10 Customers with Highest Dues
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Monitor customers with significant outstanding balances
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "top10CustomersWithHighestDues",
                          "Sales Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Purchase Dashboard Accordion */}
        <Accordion
          sx={{
            backgroundColor: colors.primary[400],
            marginBottom: "8px",
            "&:before": { display: "none" },
            "& .MuiAccordionSummary-root": {
              minHeight: "40px !important",
              padding: "0 16px",
            },
            "& .MuiAccordionSummary-content": {
              margin: "8px 0 !important",
            },
            "& .MuiAccordionDetails-root": {
              padding: "8px 16px 16px",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
          >
            <Typography variant="h5" sx={{ fontSize: "16px !important" }}>
              Purchase Dashboard
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={1}>
              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Purchase Price Variance
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Analyze differences between standard and actual purchase
                      prices
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "purchasePriceVariance",
                          "Purchase Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Top Suppliers by Spend
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Identify key suppliers based on total purchase volume
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "topSuppliersBySpend",
                          "Purchase Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Outstanding Dashboard Accordion */}
        <Accordion
          sx={{
            backgroundColor: colors.primary[400],
            marginBottom: "8px",
            "&:before": { display: "none" },
            "& .MuiAccordionSummary-root": {
              minHeight: "40px !important",
              padding: "0 16px",
            },
            "& .MuiAccordionSummary-content": {
              margin: "8px 0 !important",
            },
            "& .MuiAccordionDetails-root": {
              padding: "8px 16px 16px",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
          >
            <Typography variant="h5" sx={{ fontSize: "16px !important" }}>
              Outstanding Dashboard
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={1}>
              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Receivables Ageing Analysis
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Monitor accounts receivable by aging buckets
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "receivablesAgeingAnalysis",
                          "Outstanding Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>

              <Paper sx={{ p: 1.5 }}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box flex={1} display="flex" alignItems="center" gap={1}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "16px", fontWeight: 600 }}
                    >
                      Collection Efficiency Ratio
                    </Typography>
                    <Typography
                      variant="body2"
                      color="#B09246"
                      sx={{ fontSize: "14px", fontWeight: 500 }}
                    >
                      Measure effectiveness of collection efforts
                    </Typography>
                  </Box>

                  <Tooltip title="Configure widget settings">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<SettingsIcon />}
                      onClick={() =>
                        handleConfigureClick(
                          "collectionEfficiencyRatio",
                          "Outstanding Dashboard"
                        )
                      }
                      style={{
                        backgroundColor: colors.blueAccent[700],
                        color: colors.primary[150],
                        height: 25,
                      }}
                    >
                      Configure
                    </Button>
                  </Tooltip>
                </Box>
              </Paper>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth={false}
        PaperProps={{
          sx: {
            width: 600,
            borderRadius: 2,
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#EFE17C",
            color: "#000000",
            padding: "8px 16px",
          }}
        >
          Manage which users can view Dashboard
        </DialogTitle>

        <DialogContent sx={{ backgroundColor: "#fafafa", padding: 1 }}>
          <Box sx={{ maxHeight: "60vh", overflow: "auto" }}>
            {/* User List Section */}
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                User Access Control
              </Typography>
              <Paper variant="outlined">
                <List sx={{ p: 0 }}>
                  {loading ? (
                    <ListItem>
                      <ListItemText primary="Loading users..." />
                    </ListItem>
                  ) : users.length > 0 ? (
                    users.map((user, index) => (
                      <React.Fragment key={user.user_Id || user.id}>
                        <ListItem sx={{ py: 0.5, minHeight: "48px" }}>
                          <ListItemText
                            primary={user.user_Name || user.name}
                            secondary={`${user.user_Email || user.email} (${
                              user.user_Role || user.role
                            })`}
                            primaryTypographyProps={{
                              fontSize: "0.875rem",
                              fontWeight: 500,
                            }}
                            secondaryTypographyProps={{
                              fontSize: "0.75rem",
                            }}
                          />
                          <Switch
                            checked={user.enabled}
                            onChange={() =>
                              handleUserToggle(user.user_Id || user.id)
                            }
                            color="primary"
                            size="small"
                          />
                        </ListItem>
                        {index < users.length - 1 && <Divider />}
                      </React.Fragment>
                    ))
                  ) : (
                    <ListItem>
                      <ListItemText primary="No users found" />
                    </ListItem>
                  )}
                </List>
              </Paper>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            pb: 1,
            pt: 1,
            backgroundColor: "#fafafa",
            padding: "8px 16px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#d32f2f",
              color: "#ffffff",
              fontWeight: "bold",
              fontSize: "0.75rem",
              padding: "6px 12px",
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
            }}
            onClick={handleDialogClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#EFE17C",
              color: "#000000",
              fontWeight: "bold",
              fontSize: "0.75rem",
              padding: "6px 12px",
              "&:hover": {
                backgroundColor: "#E6D669",
              },
            }}
            onClick={handleSaveConfiguration}
          >
            Save Configuration
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
